app.mediator.registerModule(MODULE_NAME__FOOTER, function (app) {
    return {

        $rootElem: null,

        //==========================================================xdiv2====
        // Start and stop
        //===================================================================

        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },

        init: function () {

            // Init
            var scope = this;
            this.$mainElem = $('#footer');
            if (!this.$mainElem.length) { return };

            // Mediator event listeners
            app.mediator.addListener(EVENT_NAME__GALLERY__GALLERY_WITH_INFINITE_SCROLL_INITIATED, function () {
                // If the page has an infinite scroll gallery, we want to hide the footer,
                // until we have reached the last of the gallery items.
                scope.hide();
            });

            app.mediator.addListener(EVENT_NAME__GALLERY__BOTTOM_OF_INFINITE_SCROLL_REACHED, function () {
                scope.show();
            });

            app.mediator.addListener(EVENT_NAME__GALLERY_TITLE_BAR__NEW_FILTER_DATA_APPLIED, function (data) {
                scope.hide();
            });

            app.mediator.addListener(EVENT_NAME__GALLERY_FILTERS__NEW_FILTER_DATA_APPLIED, function (data) {
                scope.hide();
            });
        },

        deinit: function () {
            app.globalEventRegistry.removeListener('adjustFooter');
        },

        //==========================================================xdiv2====
        // Mediator event handlers
        //===================================================================

        // None yet

        //==========================================================xdiv2====
        // Module
        //===================================================================

        hide: function () {
            this.$mainElem.addClass('hidden');
        },

        show: function () {
            this.$mainElem.removeClass('hidden');
        }

    };
});
